export class RequestedPermissions {
    public permissions: Array<string>;
    public person_types: Array<number>;
}
export class RolesAndPermissions {
    public permissions: Array<string>;
    public person_type: number;
    constructor(response) {
        this.permissions = [];
        this.person_type = response.person_type;
        response.permissions.forEach(permission => {
            this.permissions.push(permission.permission_name);
        });
    }
    public isAuthorized(requestedPermissions: RequestedPermissions): boolean {
        let ul = 0, rl = 0;
        if (requestedPermissions.person_types) {
            rl = requestedPermissions.person_types.length;
            for (let i = 0; i < rl; i++) {
                if (requestedPermissions.person_types[i] == this.person_type) {
                    return true;
                }
            }
        }
        if (requestedPermissions.permissions) {
            ul = this.permissions.length;
            rl = requestedPermissions.permissions.length;
            for (let i = 0; i < ul; i++) {
                for (let j = 0; j < rl; j++) {
                    if (requestedPermissions.permissions[j].toLowerCase() == this.permissions[i].toLowerCase()) {
                        return true;
                    }
                }
            }
        }
        return false;

    }
}